export const FETCH_SALESFORCE_DATA = 'FETCH_SALESFORCE_DATA';
export const SALESFORCE_DATA_READY = 'SALESFORCE_DATA_READY';
export const FRONT_INFORMATIONS_READY = 'FRONT_INFORMATIONS_READY';
export const SEND_BACK_DATA_TO_SALESFORCE = 'SEND_BACK_DATA_TO_SALESFORCE';
export const OPPORTUNITY_NEED_UPDATE = 'OPPORTUNITY_NEED_UPDATE';
export const UPDATE_OPPORTUNITY_STORAGE = 'UPDATE_OPPORTUNITY_STORAGE';

export function fetchSalesforceData(accountId, opportunityId) {
  return {
    type: FETCH_SALESFORCE_DATA,
    accountId,
    opportunityId,
  };
}

export function SfDataReady(account, opportunity, shippingAddress, quotation) {
  return {
    type: SALESFORCE_DATA_READY,
    account,
    opportunity,
    shippingAddress,
    quotation,
  };
}

export function frontInformationsReady(customerInformations, customerAddress, customerDetails) {
  return {
    type: FRONT_INFORMATIONS_READY,
    customerInformations,
    customerAddress,
    customerDetails,
  };
}

export function sendBackDataToSalesforce() {
  return {
    type: SEND_BACK_DATA_TO_SALESFORCE,
  };
}

export function opportunityNeedUpdate(opportunityId, stageValue, stageNumber) {
  return {
    type: OPPORTUNITY_NEED_UPDATE,
    stageValue,
    stageNumber,
  };
}

export function updateOpportunityStorage(opportunity) {
  return {
    type: UPDATE_OPPORTUNITY_STORAGE,
    opportunity,
  };
}



// WEBPACK FOOTER //
// ./src/services/DataServices/SFDataService/actions.js